<template>
  <div class="wrap">
    <mt-header title="安全验证">
      <router-link to="/more/showinfo" slot="left">
        <span class="quxiao">取消</span>
      </router-link>
    </mt-header>
    <div class="main">
      <span class="tip">为了保证您的帐号安全，请验证身份。验证成功后进行下一步操作。</span>
    </div>
    <h3 class="telNum" v-model="phone">你的手机号：{{phone}}</h3>
    <div style="padding: 0 .4rem">
      <mt-button type="primary" size="large" class="btn" @click="sendMsg">修改手机号</mt-button>
    </div>
  </div>
</template>
<script>
//  import apis from '../../apis/index'
//  import cloudApi from '../../apis/cloudStorageApi'

  export default {
    data () {
      return {
        phone: '',
        phone1: ''
      }
    },
    created () {
      this.phone = JSON.parse(sessionStorage.mobileData).phone
//      this.phone1 = this.phone.substr(0, 3) + '****' + this.phone.substr(7)
    },
    methods: {
      sendMsg () {
        var _this = this
        _this.$router.push({path: '/more/acceptcode'})
      }
    }
  }
</script>
<style scoped>
  .wrap {
    padding-top: 1.28rem;
    height: 100%;
    background: #f7f7fa;
  }

  .mint-header {
    position: fixed;
    top: 0;
    height: 1.28rem;
    width: 100%;
    background-color: #E4393C;
  }

  .quxiao {
    font-size: .28rem;
  }

  .mint-header-title {
    font-size: .36rem;
    font-weight: 500;
  }

  .mint-button-text {
    font-size: .28rem;
  }

  .main {
    padding: .2rem .54rem 0 .29rem;
  }

  .main .tip {
    color: #9b9b9b;
    font-size: .28rem;
    text-align: left;
  }

  .telNum {
    text-align: center;
    font-size: .3rem;
    color: #1d1f22;
    margin: .52rem 0;
  }

  .mint-button--primary {
    background: #E4393C;
  }

  .btn {
    height: .94rem;
    line-height: .94rem;
    font-weight: 500;
  }
</style>
<style>
  .mint-header-title {
    font-size: .36rem;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/views/more/changephone.vue